import {serializeType} from "./common";
import {ContractClinFunding} from "./contract-clin-funding";
import {BillingType} from "@app/shared/enums/billing-type.enum";
import {ClinType} from "@app/shared/enums/clin-type.enum";
import {RevenueRecognitionType} from "@app/shared/enums/revenue-recognition-type.enum";
import {Type} from "class-transformer";
import {BillingLevelType} from "@app/shared/enums/billing-level-type";

export class ContractClin {
  id: number;
  version: number;
  name: string;
  number: string;
  suppliesOrServices: string;
  quantityOrdered: number;
  unitPrice: number;
  clinType: ClinType;
  billingType: BillingType;
  revenueAccountGroupId?: number;
  isRevenueAccountGroupMapped?: boolean;
  revenueRecognitionType?: RevenueRecognitionType;
  totalLaborAmount?: number;
  totalTravelAmount?: number;
  totalExpenseAmount?: number;
  billingPercent?: number;
  numberOfBills?: number;
  unitofMeasureId: number;
  unitofMeasureName?: string;
  contractModId?: number;
  revenuePlanId?: number;
  modNumber?: string;
  // statusId: number;
  contractId?: number;        // transient
  contractOptionId: number;
  clinBillingPlanId?: number;
  clinBillingPlanName?: string;
  clinBillingLevelType?: BillingLevelType;
  @Type(serializeType(ContractClinFunding)) clinFundings?: ContractClinFunding[];
}

export class ContractClinInfo {
  id: number;
  billingType: BillingType;
  revenueRecognitionType: RevenueRecognitionType;
  clinType: ClinType;
  name: string;
  clinNumber: string;
  totalLaborAmount: number;
  totalTravelAmount: number;
  totalExpenseAmount: number;
  billingPercent: number;
}
